var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-block"},[_c('div',{staticClass:"content-block__container"},[_c('RawHtml',{staticClass:"rte",attrs:{"html":_vm.newData.htmlContent[_vm.$i18n.locale],"data-test-id":"legacy-text-block-content"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }